import { useState } from "react";
import '../../css/preguntasFrecuentes.scss'
import MapaPichi from "../frames/MapaPichi";
import MapaTopo from "../frames/MapaTopo";
import MapaMaza from "../frames/MapaMaza";

// Example FAQ data
const FAQ_DATA = {
    autoridades: [
      { q: "¿Quiénes son las autoridades competentes?", a: "Las autoridades competentes incluyen Asipona en Mazatlán, Asipona en Topolobampo y API BCS en Pichilingue." },
      { q: "¿Dónde puedo contactarlas?", a: (<>
      <p>El número de contacto para ASIPONA Topolobampo es 668 816 39 70. </p>
      <p>El número de contacto para ASIPONA Mazatlán es 669 982 3611.</p>    
      <p>El número de contacto para API BCS es 612 123 6500.</p>    
        
      </>) },
    ],
    documentacion: [
      { q: "¿Cuáles son las identificaciones oficiales para viajar?", a: (
        <>
        <label>Identificación oficial vigente, expedida por el Instituto Nacional Electoral (INE)</label><br/>
        <label>Puede ser:</label><br/>
        <label>- Pasaporte vigente</label><br/>
        <label>- Cédula profesional vigente con fotografía.</label><br/>
        <label>En el caso de menores de edad: acta de nacimiento original, credencial emitida por Instituciones de Educación Pública o Privada con reconocimiento de validez oficial con fotografía y firma o pasaporte.</label><br/>
        <label>Si eres extranjero: Pasaporte o documento migratorio vigente que corresponda, emitido por autoridad competente (en su caso, prórroga o refrendo migratorio)</label>
        
        </>
      ) },
      
    ],
    puertos: [
      { q: "¿Cómo puedo llegar al puerto de Pichilingue?", a: (
          <>
              <p>
                  El Puerto de Pichilingue se encuentra en Interior Muelle de Altura API, 
                  Lt. 1, Mzn. F, C.P. 23208, La Paz, B.C.S.
              </p>
              <MapaPichi />
          </>
        ), },
      { q: "¿Dónde se encuentra ubicado el puerto de Topolobampo?", a: (
          <>
              <p>
                  Ubicado en Muelle de Transbordadores S/N, Interior Instalaciones API, 
                  Col. Cerro de la Gallina, C.P. 81370, Topolobampo, Sinaloa.
              </p>
              <MapaTopo />
          </>
        ), },
      { q: "¿Cuál es la dirección del puerto de Mazatlán?", a: (
          <>
              <p>
                  Ave. Emilio Barragán y Prol. Carnaval S/N, Fracc. Playa Sur, C.P. 82040,
                  Instalaciones API, Mazatlán, Sinaloa.
              </p>
              <MapaMaza />
          </>
        ), },
    ],
    horarios: [
      { q: "¿Cuál es el horario de atención en corporativo?", a: <>
          <div>
            <p>Horarios de atención:</p>
            <label>Lunes a Viernes: 9:00 a 17:00 hrs</label>
            <br/>
            <label>Sábado: 8:00 a 14:00 hrs</label>
            <br/>
            <ul>
              <li> 800 337 7437</li>
              <li>+52 (612) 123 6600</li>
              <li> contactcenter@bajaferries.com.mx</li>
            </ul>          
          </div>
      </>},
      { q: "¿Cuál es el horario de atención en contact center?", a: <>
          <div>
            <p>Horarios de atención:</p>
            <label>Lunes a Viernes: 7:00 a 21:00 hrs</label>
            <br/>
            <label>Sábado: 8:00 a 20:00 hrs</label>
            <br/>
            <ul>
              <li> 800 337 7437</li>
              <li>+52 (612) 123 6600</li>
              <li> contactcenter@bajaferries.com.mx</li>
            </ul>          
          </div>
      </>},
      { q: "¿Cuál es el horario de atención en Pichilingue?", a: <>
          <div>
            <p>Horarios de atención:</p>
            <label>Lunes, Miércoles y Viernes: 7:00 a 15:00 hrs</label>
            <br/>
            <label>Martes y Jueves: 7:00 a 20:00 hrs</label>
            <br/>
            <label>Sábado: 8:00 a 23:30 hrs</label>
            
            <br/>
            <ul>
              <li> 800 337 7437</li>
              <li>+52 (612) 123 6600</li>
              <li> contactcenter@bajaferries.com.mx</li>
            </ul>          
          </div>
      </>},
      { q: "¿Cuál es el horario de atención en Topolobampo?", a: <>
          <div>
            <p>Horarios de atención:</p>
            <label>Lunes a Viernes: 9:00 a 00:00 hrs</label>
            <br/>
            <label>Sábado: 9:00 a 15:00 hrs</label>
            <br/>
            <label>Domingo: 9:00 a 00:00 hrs</label>
              <br/>
            <ul>
              <li> 800 337 7437</li>
              <li>+52 (612) 123 6600</li>
              <li> contactcenter@bajaferries.com.mx</li>
            </ul>          
          </div>
      </>},
      { q: "¿Cuál es el horario de atención en Mazatlán?", a: <>
          <div>
            <p>Horarios de atención:</p>
            <label>Lunes a Viernes: 8:00 a 16:00 hrs</label>
            <br/>
            <label>Sábado: 8:00 a 14:00 hrs</label>
            <br/>
            <label>Domingo: 8:00 a 16:00 hrs</label>
            <br/>
            <ul>
              <li> 800 337 7437</li>
              <li>+52 (612) 123 6600</li>
              <li> contactcenter@bajaferries.com.mx</li>
            </ul>          
          </div>
      </>},
      { q: "¿Cuál es el horario de atención en los Mochis?", a: <>
          <div>
            <p>Horarios de atención:</p>
            <label>Lunes a Viernes: 10:00 a 18:00 hrs</label>
            <br/>
            <label>Sábado: 9:00 a 15:00 hrs</label>
            <br/>
            <ul>
              <li> 800 337 7437</li>
              <li>+52 (612) 123 6600</li>
              <li> contactcenter@bajaferries.com.mx</li>
            </ul>          
          </div>
      </>},
    ],
    reservacion: [
      { q: "¿Qué incluye mi boleto?", a: (
        <>
        <p><strong>Servicios a bordo:</strong></p>
        <ul>
          <li>Un asiento en nuestra sala de descanso. (sujeto a disponibilidad)
            <ul>
              <li>Puedes reservar tu lugar en la Sala VIP o en cabinas (consulta tarifas y disponibilidad).</li>
            </ul>
          </li>
          <li>Alimentos tipo buffet antes del zarpe.</li>
          <li>Café con pan antes de arribar al destino.</li>
        </ul>
        <p><strong>No abordes con: </strong></p>
        <ul>
          <li>Alimentos</li>
          <li>Bebidas</li>
          <li>Cobijas, colchonetas ni almohadas.</li>
        </ul>
        <p><strong>Equipaje</strong>:</p>

        <ul>
          <li><strong>A bordo</strong>: Artículo personal y maleta de mano (hasta 10 kg).</li>
          <li><strong>Documentado</strong>: Hasta 5 maletas adicionales sin costo (cada una hasta 25 kg).</li>
        </ul>

        <label>Nota: </label><br />

        <ul>
          <li>Si excedes el peso permitido, Baja Ferries no podrá hacerse responsable del manejo ni de posibles daños.</li>
          <li>Está permitido abordar con frazadas ligeras</li>
        </ul>

          
        </>
      ) },
      { q: "¿Puedo transferir mi boleto?", a: "No, el boleto por ningún motivo puede ser transferible ni reembolsable." },
      { q: "Escribí mal mi nombre al momento de reservar, ¿puedo editarlo?", a: "Sí. Solo en caso de corrección por error ortográfico u omisión de nombre o apellido es posible editarlo llamando al Contact Center. Este servicio no tiene costo." },
      { q: "Necesito modificar la fecha de mi viaje, ¿puedo hacerlo?", a: (
        <>
        <p>Sí, puedes modificar la fecha de tu viaje; solo debes notificar a nuestro equipo 48 horas antes de tu nueva fecha.</p>
        <p>El boleto tiene una vigencia de 12 meses. Durante ese periodo puedes cambiar tu boleto hasta tres veces, cubriendo un costo de $580.00 MXN por cada cambio, más la diferencia de tarifa en caso de existir.</p>
        <p>Recuerda que cualquier modificación está sujeta a disponibilidad de espacio. Consulta nuestras rutas, horarios y tarifas.</p>
        <p>Nota: El boleto es personal e intransferible.</p>
        </>
      )},

    ],
};

export default function PreguntasFrecuentesAntes() {
    const [activeTopic, setActiveTopic] = useState("puertos");
    const [openQuestion, setOpenQuestion] = useState(null);

    const topics = [
        { id: "puertos", label: "Puertos" },
        { id: "horarios", label: "Horarios" },
        { id: "reservacion", label: "Reservación" },
        { id: "autoridades", label: "Autoridades" },
        { id: "documentacion", label: "Documentación" },        
    ];

    const handleQuestionToggle = (index) => {
        setOpenQuestion((prev) => (prev === index ? null : index));
    };

  return (
    <>
    <section className="preguntas-frecuentes">
        <div className="container">
            <div className='preguntas-frecuentes-title'>
                <h2>Preguntas frecuentes</h2>
                <p>Hemos recopilado las consultas más comunes de nuestros clientes. </p>
            </div>
        </div>

        <div className="w-full max-w-2xl mx-auto p-4 space-y-6">
        {/* Topic Buttons */}
        <div className="flex flex-wrap gap-3 justify-center topic-buttons">
            {topics.map((t) => (
            <button
                key={t.id}
                className={`topic-btn ${activeTopic === t.id ? "active" : ""}`}
                onClick={() => {
                setActiveTopic(t.id);
                setOpenQuestion(null);
                }} >
                {t.label}
            </button>
            ))}
        </div>

        {/* FAQ List */}
        <div className="faq-list">
            {FAQ_DATA[activeTopic].map((item, i) => (
            <div key={i} className={`faq-item ${openQuestion === i ? "active-question" : ""}`} >
                <div className="faq-content">
                <button
                    className="faq-box"
                    onClick={() => handleQuestionToggle(i)}>
                    {item.q}
                    <i
                    className={`fi ${
                        openQuestion === i ? "fi-rr-minus-circle" : "fi-rr-add"
                    } text-xl`}
                    ></i>
                </button>

                {openQuestion === i && (
                    <p className="mt-3 text-base text-gray-700 respuesta">{item.a}</p>
                )}
                </div>
            </div>
            ))}
        </div>
        </div>
    </section>
    </>
  );
}
